export const useDates = (duration: number, addDays?: number, formatDot?: boolean): string[] => {
	const now = new Date();

	const formatDate = (date: Date, formatDot?: boolean): string => {
		if (formatDot) {
			return date.toLocaleDateString('en-GB').replaceAll('/', '.');
		}
		const result = date.toLocaleString('default', {
			day: 'numeric',
			month: 'short',
			year: 'numeric',
		});
		return result.replaceAll(' ', '\u00A0');
	};

	const endDate = (): string => {
		const result = new Date(now);
		result.setDate(result.getDate() + duration * 7 + (addDays ?? 0));

		return formatDate(result, formatDot);
	};

	return [formatDate(now, formatDot), endDate()];
};
